
import { Component, Mixins } from 'vue-property-decorator';
import { createShipmentQueryParams } from '@/features/common/raw';
import { PackageItem, PackageType } from '@/features/shipment/types';
import { fieldValue, parsePackages, parseQueryField } from '@/features/query-string/helpers';
import PackageSummary from '@/features/shipment/components/createShipment/packageSummary/PackageSummary.vue';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component({
  components: {
    PackageSummary,
  },
})
export default class Debug extends Mixins(ResponsivenessMixin) {
  private queryParams = createShipmentQueryParams;

  get fromParams(): string[] {
    return this.queryParams
      .filter(({ parameter }) => parameter.slice(0, 4) === 'From')
      .map(({ parameter }) => parameter);
  }

  get toParams(): string[] {
    return this.queryParams
      .filter(({ parameter }) => parameter.slice(0, 2) === 'To')
      .map(({ parameter }) => parameter);
  }

  get packages(): PackageItem[] {
    return parsePackages(this.$route.query);
  }

  get packageType(): string {
    if (this.packages.length === 1) {
      return this.packages[0].packageType;
    }

    return PackageType.MyPackage;
  }

  private getFieldValue(field: string): fieldValue {
    const { query } = this.$route;
    return parseQueryField(query, field);
  }
}
